import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import {
  Activity,
  BaggageClaim,
  Briefcase,
  Cpu,
  Dumbbell,
  FileClock,
  Fingerprint,
  GraduationCap,
  HardDrive,
  Hotel,
  Landmark,
  LayoutDashboard,
  LUCIDE_ICONS,
  LucideIconProvider,
  Network,
  Plane,
  Play,
  QrCode,
  Radar,
  RadioTower,
  ShieldCheck,
  Sparkles,
  Tent,
  Waves,
} from 'lucide-angular';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';

const lucideIcons = {
  Activity,
  BaggageClaim,
  Briefcase,
  Cpu,
  Dumbbell,
  FileClock,
  Fingerprint,
  GraduationCap,
  HardDrive,
  Hotel,
  Landmark,
  LayoutDashboard,
  Network,
  Plane,
  Play,
  QrCode,
  Radar,
  RadioTower,
  ShieldCheck,
  Sparkles,
  Tent,
  Waves,
};

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(lucideIcons) }
  ]
}).catch((err) => console.error(err));
